import request from '@/utils/http'

export function advertDisplayGet(data) {
  return request({
    url: 'advert.display.get',
    method: 'get',
    params: data
  })
}